import { b2x } from '@b2x/react/src';
import { SwiperSlide } from 'swiper/react';

import { AddToCartQuantitySelect } from './AddToCartQuantitySelect';
import { Button } from './Button';
import { t } from './i18n/i18n';
import { Slider } from './slider/Slider';

export type RecommendedCartProductTileExtraInfoProps = b2x.RecommendedCartProductTileExtraInfoProps;

export const RecommendedCartProductTileExtraInfo = ({
  fieldsHelper,
  onToggleShowMore,
  priceHelper,
  product,
  sku,
}: RecommendedCartProductTileExtraInfoProps) => (
  <b2x.Div paddingTop={2}>
    <b2x.Row gap={3}>
      <b2x.Col size={{ md: '', xs: '' }}>
        <b2x.FormGroup {...fieldsHelper.productVariantsFieldSet.productVariants.formGroup} noMarginBottom>
          <Slider slidesPerView={'auto'} spaceBetween={8}>
            {fieldsHelper.productVariantsFieldSet.productVariants.formFields.map((formField, index) => (
              <SwiperSlide key={formField.radio.id}>
                <b2x.Radio
                  key={formField.productVariant.id}
                  noMargin
                  {...formField.radio}
                  inline
                  labelClassName="mb-1 small text-secondary border border-1 bg-gray-200 border-gray-200 py-1 px-2"
                >
                  {formField.productVariant.skus?.map((productVariantSku) => productVariantSku.name)}
                </b2x.Radio>
              </SwiperSlide>
            ))}
          </Slider>
        </b2x.FormGroup>
      </b2x.Col>
      <b2x.Col size={{ sm: 'auto', xs: 12 }}>
        <b2x.Row>
          <b2x.Col size={{ sm: 'auto', xs: 'auto' }}>
            <AddToCartQuantitySelect
              ariaLabel={t('accessibility.select.quantity', { productName: product.name })}
              className="quantity-select text-center"
              fieldsHelper={fieldsHelper}
              selectedSku={sku}
            />
          </b2x.Col>
          <b2x.Col alignItems={'center'} display={{ md: 'none', xs: 'flex' }} justifyContent={'end'}>
            <b2x.PriceBlock hiddenDiscountPercentage priceHelper={priceHelper} />
          </b2x.Col>
        </b2x.Row>
      </b2x.Col>
      <b2x.Col size={12}>
        <b2x.Div display={'flex'} gap={3} justifyContent={'end'}>
          <Button className="p-0" size="small" type="submit" variant="link">
            {t('form.recommendedCartProduct.buttons.submit.label')}
          </Button>
          <Button className="p-0" onClick={onToggleShowMore} size="small" type="button" variant="link">
            {t('form.recommendedCartProduct.buttons.reset.label')}
          </Button>
        </b2x.Div>
      </b2x.Col>
    </b2x.Row>
  </b2x.Div>
);
